import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/buyReadyProducts',
  component: Layout,
  name: 'buyReadyProducts',
  redirect: '/buyReadyProducts/index',
  children: [{
    path: '/buyReadyProducts/index',
    component: () => import('@/views/buyReadyProducts/index'),
    name: 'buyReadyProducts.index',
    meta: {
      title: i18n.t(`message.buy_ready_products`)
    }
  }, ]
}

export default paymentType